import AxiosInterceptor from "../utils/AxiosInterceptor";

const contestmanagerapi = {
  add: (value) => AxiosInterceptor().post(`/contests/createContest`, value),
  edit: (value) => AxiosInterceptor().post(`/contests/updateContest`, value),
  delete: (value) => AxiosInterceptor().post(`/contests/deleteContest`, value),
  getAll: (values) => AxiosInterceptor().post(`/contests/getAllContests`, values),
  getById: (id) => AxiosInterceptor().get(`/contests/getOneContest/${id.id}`,),
  changeStatus: (values) =>
    AxiosInterceptor().post(`/contests/changeStatus`, values),
};

export default contestmanagerapi;
